import { render, staticRenderFns } from "./ExcelPageTable.vue?vue&type=template&id=5391b20e&scoped=true"
import script from "./ExcelPageTable.vue?vue&type=script&lang=js"
export * from "./ExcelPageTable.vue?vue&type=script&lang=js"
import style0 from "./ExcelPageTable.vue?vue&type=style&index=0&id=5391b20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391b20e",
  null
  
)

export default component.exports